/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MarkPalAuthSubmissionAsManualRequest
 */
export interface MarkPalAuthSubmissionAsManualRequest {
    /**
     * Optional comment explaining the manual submission
     */
    comment?: string;
}

/**
 * Check if a given object implements the MarkPalAuthSubmissionAsManualRequest interface.
 */
export function instanceOfMarkPalAuthSubmissionAsManualRequest(value: object): value is MarkPalAuthSubmissionAsManualRequest {
    return true;
}

export function MarkPalAuthSubmissionAsManualRequestFromJSON(json: any): MarkPalAuthSubmissionAsManualRequest {
    return MarkPalAuthSubmissionAsManualRequestFromJSONTyped(json, false);
}

export function MarkPalAuthSubmissionAsManualRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarkPalAuthSubmissionAsManualRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}

export function MarkPalAuthSubmissionAsManualRequestToJSON(json: any): MarkPalAuthSubmissionAsManualRequest {
    return MarkPalAuthSubmissionAsManualRequestToJSONTyped(json, false);
}

export function MarkPalAuthSubmissionAsManualRequestToJSONTyped(value?: MarkPalAuthSubmissionAsManualRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'comment': value['comment'],
    };
}

